import React from 'react'
import { PopupContainerProps } from './PopupContainer.types'
import styles from './PopupContainer.module.scss'
import cl from 'classnames'

const PopupContainerComponent = (props: PopupContainerProps) => {
  const {
    className,
    style,
    children
  } = props

  return (
    <div
      className={cl(styles.overlayContainer, className)}
      style={style}
    >
      {children}
    </div>
  )
}

const PopupContainer = PopupContainerComponent
export { PopupContainer }
